<template>
	<div class="am-specs">
		<div class="am-specs__item">
			<am-icon class="am-specs__icon" name="pin" size="xl" />

			<div class="am-specs__wrapper">
				<am-text class="am-specs__label" type="caption">
					Área total de
				</am-text>
				<am-text class="am-specs__value" type="subtitle">
					251.862,95m²
				</am-text>
			</div>
		</div>

		<div class="am-specs__item">
			<am-icon class="am-specs__icon" name="home" size="xl" />

			<div class="am-specs__wrapper">
				<am-text class="am-specs__label" type="caption">
					Sonhos entre
				</am-text>
				<am-text class="am-specs__value" type="subtitle">
					420m² e 914m²
				</am-text>
			</div>
		</div>

		<div class="am-specs__item">
			<am-icon class="am-specs__icon" name="trees" size="xl" />

			<div class="am-specs__wrapper">
				<am-text class="am-specs__label" type="caption">
					Área do Parque
				</am-text>
				<am-text class="am-specs__value" type="subtitle">
					66.781,59m²
				</am-text>
			</div>
		</div>

		<div class="am-specs__item">
			<am-icon class="am-specs__icon" name="fullscreen" size="xl" />

			<div class="am-specs__wrapper">
				<am-text class="am-specs__label" type="caption">
					Ilha de Lazer
				</am-text>
				<am-text class="am-specs__value" type="subtitle">
					18.425m²
				</am-text>
			</div>
		</div>
	</div>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMIcon from '@/components/atoms/AMIcon'

export default {
	components: {
		'am-text': AMText,
		'am-icon': AMIcon,
	}
}
</script>

<style lang="scss">
.am-specs{
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	&__icon{
		margin-right: 16px;
		transform: scale(.8);
	}
	&__item{
		width: 50%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 8px 0;
		&:last-child{
			border-bottom: 0;
		}
	}
	&__label{
		font-size: 9px;
		line-height: 10px;
		margin-bottom: 5px;
	}
	&__value{
		font-size: 16px;
		line-height: 18px;
	}

	@include grid-media($desktop-grid) {
		flex-flow: row;
		align-items: center;
		&__icon{
			transform: none;
		}
		&__item{
			flex: 1;
			border: 0;
			padding: 0;
			justify-content: center;
			&:last-child{
				border-right: 0;
			}
			&:first-child{
				display: none;
			}
		}
		&__value{
			font-size: 25px;
			line-height: 24px;
		}
	}
}
</style>
